<script lang="ts">
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *  2025-04-09 (1.0.0) (jhoward)
 *    - <menu-item-price> handles displaying prices for dining menu items.
 */

import {defineComponent} from 'vue';

interface PerPersonRegExpExecArray extends RegExpExecArray {
  groups?: {
    price?: string;
  };
}

export default defineComponent({
  name: "MenuItemPrice",
  props: {
    priceToDisplay: {
      type: String,
      required: true
    },
    priceLabel: {
      type: String,
      default: ''
    },
    ariaPrefix: {
      type: String,
      default: ''
    },
    ariaSuffix: {
      type: String,
      default: ''
    },
  },
  computed: {
    isPriceAriaHidden(): boolean {
      return !!this.priceLabel.length;
    },
  },
})
</script>

<template>
  <span class="menu--item_price" :aria-label="(priceLabel.length) ? priceLabel : null">
    <slot name="before-price"></slot>

    <span v-if="isPriceAriaHidden" v-html="priceToDisplay" aria-hidden="true"></span>
    <span v-else v-html="priceToDisplay"></span>

    <slot name="after-price"></slot>
  </span>
</template>

<style scoped>
.menu--item_price {
  text-align: right;
}

.visual_menu--section .menu--section_subgroup:not(.menu--section_subgroup-show_BIN) .menu--item:not(.menu--item-price_header) .menu--item_price {
  grid-row: 1 / 3;
  grid-column: 2;
}

.menu--item-price_inline .menu--item_price {
  margin-left: 0.6em;
}
</style>